import { useState } from "react";
import { api, saveSession, type User } from "../api";

export default function Login({ onDone }: { onDone: (u: User) => void }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await api<{ token: string; user: User }>("/api/auth/login", {
        method: "POST",
        body: { login: login.trim(), password },
      });
      await saveSession(res.token, res.user);
      onDone(res.user);
    } catch (e: any) {
      setError(
        e?.status === 0
          ? "Нет связи. Первый вход нужно сделать при интернете."
          : e?.message ?? "Не удалось войти"
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app">
      <div className="body">
        <form className="center" onSubmit={submit}>
          <div className="logo" aria-hidden="true">L</div>
          <div style={{ textAlign: "center", marginBottom: 26 }}>
            <div style={{ fontSize: 20, fontWeight: 660, letterSpacing: "-.015em" }}>Lacalut CRM</div>
            <div className="hint" style={{ marginTop: 4 }}>Визиты по аптекам и стоматологиям</div>
          </div>

          {error && <div className="err">{error}</div>}

          <div className="field">
            <label className="label" htmlFor="lg">Логин</label>
            <input id="lg" className="inp" value={login} autoComplete="username"
              autoCapitalize="none" autoCorrect="off"
              onChange={(e) => setLogin(e.target.value)} required />
          </div>
          <div className="field">
            <label className="label" htmlFor="pw">Пароль</label>
            <input id="pw" className="inp" type="password" value={password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)} required />
          </div>

          <button className="btn primary wide" type="submit" disabled={busy || !login || !password}>
            {busy ? "Входим…" : "Войти"}
          </button>
          <div className="hint" style={{ marginTop: 14, textAlign: "center" }}>
            Пароль задаётся один раз по ссылке-приглашению.<br />
            Забыл — попроси новую ссылку у руководителя.
          </div>
        </form>
      </div>
    </div>
  );
}
